interface NetInfo {
  isOnline: boolean;
}

export const useNetInfo = (): NetInfo => {
  const isOnline = navigator.onLine;

  return {
    isOnline
  };
};
